import { UseMediaQueryOptions } from './use-match-media'
import { useMediaQuery } from './use-match-media'

export function useReducedMotion(initialValue?: boolean, options?: UseMediaQueryOptions) {
  return useMediaQuery('(prefers-reduced-motion: reduce)', initialValue, options)
}
